import React, { useMemo, useState } from "react";
import "./Catalogo.css";
import { Link } from "react-router-dom";

/* ==== Imágenes de Jugos Cítricos ==== */
import LimonadaYerbabuenaImg from "./imagenes/imag-jugos/Limonada yerbabuena.jpg";
import MandarinoImg from "./imagenes/imag-jugos/Mandarino publi.png";
import MesinoImg from "./imagenes/imag-jugos/Mesino publi.jpg";
import NaranjaImg from "./imagenes/imag-jugos/Naranja publi.jpg";

/* ==== Pulpas ==== */
import FresaImg from "./imagenes/imag-pulpas/Fresa.jpg";
import CarambolaImg from "./imagenes/imag-pulpas/Carambola.jpg";
import CasImg from "./imagenes/imag-pulpas/Cas.jpg";
import GuanabanaImg from "./imagenes/imag-pulpas/Guanabana.jpg";
import MangoImg from "./imagenes/imag-pulpas/Mango.jpg";
import MaracuyaImg from "./imagenes/imag-pulpas/Maracuya.jpg";
import MixtoImg from "./imagenes/imag-pulpas/Mixto.png";
import MoraImg from "./imagenes/imag-pulpas/Mora.jpg";
import PinaImg from "./imagenes/imag-pulpas/Pina.jpg";
import Tamarindo2LImg from "./imagenes/imag-pulpas/Tamarindo 2L.png";
import TamarindoImg from "./imagenes/imag-pulpas/Tamarindo.jpg";

/* ==== Grasas y Aceites ==== */
import Aceite1893Img from "./imagenes/imag-grasas/Aceite 18.93.png";
import AceiteOleinaImg from "./imagenes/imag-grasas/Aceite oleina.png";
import MantecaMultiImg from "./imagenes/imag-grasas/Manteca Multi.jpeg";
import MantecaPalmaImg from "./imagenes/imag-grasas/Manteca Palma.png";
import MargarinaHojaldreImg from "./imagenes/imag-grasas/Margarina Hojaldre.png";
import MargarinaMultipropositoImg from "./imagenes/imag-grasas/Margarina Multipropósito.png";
import MargarinaPasteleraImg from "./imagenes/imag-grasas/Margarina Pastelera.png";

/* ==== Jugos adicionales ==== */
import NaranjaZanahoriaImg from "./imagenes/imag-pulpas/Naranja con Zanahoria.png";
import NaranjaRemolachaAltImg from "./imagenes/imag-pulpas/Naranja con Remolacha.png";

/* ==== Sabores Especiales ==== */
import CoctelPasionPresentacionImg from "./imagenes/imag-pulpas/coctel_pasion.png";
import CremaCocoImg from "./imagenes/imag-pulpas/Crema de coco- Presentación.png";
import PinaColadaPresentacionImg from "./imagenes/imag-pulpas/Piña Colada- Presentación.png";
import PinaArrozPresentacionImg from "./imagenes/imag-pulpas/Piña con Arroz - Presentación.png";
import ResbaladeraPresentacionImg from "./imagenes/imag-pulpas/Resbaladera- Presentación.png";

/* ==== Frutas Congeladas ==== */
import CarambolaFrutaImg from "./imagenes/imagenes-frutas/Carambola.png";
import CasFrutaImg from "./imagenes/imagenes-frutas/Cas.png";
import GuanabanaFrutaImg from "./imagenes/imagenes-frutas/Guanabana.png";
import MaracuyaFrutaImg from "./imagenes/imagenes-frutas/Maracuya.png";
import MixtoFrutasImg from "./imagenes/imagenes-frutas/Mixto Frutas.png";
import MoraFrutaImg from "./imagenes/imagenes-frutas/Mora.png";
import PapayaFrutaImg from "./imagenes/imagenes-frutas/Papaya.png";
import PinaFrutaImg from "./imagenes/imagenes-frutas/Piña.png";
import SandiaFrutaImg from "./imagenes/imagenes-frutas/Sandía.png";
import MangoFrutaImg from "./imagenes/imagenes-frutas/Mango.png";
import FresaFrutaImg from "./imagenes/imagenes-frutas/Fresa.png";




const PRODUCTS = [
  /* ==== Frutas Congeladas ==== */
  {
    id: "fruta-guanabana",
    name: "Guanábana",
    category: "frutas",
    lines: ["congeladas"],
    desc: "Fruta de guanábana congelada, ideal para preparar batidos, refrescos y postres.",
    presentations: ["1 kg"],
    prices: { congeladas: { "1 kg": 2260 } },
    img: GuanabanaFrutaImg,
  },
  {
    id: "fruta-sandia",
    name: "Sandía",
    category: "frutas",
    lines: ["congeladas"],
    desc: "Sandía congelada, refrescante y práctica para bebidas y preparaciones frutales.",
    presentations: ["1 kg"],
    prices: { congeladas: { "1 kg": 2020 } },
    img: SandiaFrutaImg,
  },
  {
    id: "fruta-mixto",
    name: "Mixto de Frutas",
    category: "frutas",
    lines: ["congeladas"],
    desc: "Mezcla congelada de mango, papaya, fresa, piña y melón, ideal para batidos y ensaladas de frutas.",
    presentations: ["1 kg"],
    prices: { congeladas: { "1 kg": 2260 } },
    img: MixtoFrutasImg,
  },
  {
    id: "fruta-cas",
    name: "Cas",
    category: "frutas",
    lines: ["congeladas"],
    desc: "Cas congelado para refrescos tradicionales, batidos y otras preparaciones.",
    presentations: ["1 kg"],
    prices: { congeladas: { "1 kg": 2260 } },
    img: CasFrutaImg,
  },
  {
    id: "fruta-mango",
    name: "Mango",
    category: "frutas",
    lines: ["congeladas"],
    desc: "Mango congelado, dulce y tropical, ideal para batidos y postres.",
    presentations: ["1 kg"],
    prices: { congeladas: { "1 kg": 2020 } },
    img: MangoFrutaImg,
  },
  {
    id: "fruta-pina",
    name: "Piña",
    category: "frutas",
    lines: ["congeladas"],
    desc: "Piña congelada, lista para bebidas, coctelería y recetas tropicales.",
    presentations: ["1 kg"],
    prices: { congeladas: { "1 kg": 2020 } },
    img: PinaFrutaImg,
  },
  {
    id: "fruta-carambola",
    name: "Carambola",
    category: "frutas",
    lines: ["congeladas"],
    desc: "Carambola congelada de sabor tropical, perfecta para refrescos y batidos.",
    presentations: ["1 kg"],
    prices: { congeladas: { "1 kg": 2020 } },
    img: CarambolaFrutaImg,
  },
  {
    id: "fruta-papaya",
    name: "Papaya",
    category: "frutas",
    lines: ["congeladas"],
    desc: "Papaya congelada, práctica para smoothies, batidos y postres.",
    presentations: ["1 kg"],
    prices: { congeladas: { "1 kg": 2020 } },
    img: PapayaFrutaImg,
  },
  {
    id: "fruta-fresa",
    name: "Fresa",
    category: "frutas",
    lines: ["congeladas"],
    desc: "Fresa congelada, ideal para batidos, repostería y bebidas.",
    presentations: ["400 g"],
    prices: { congeladas: { "400 g": 2260 } },
    img: FresaFrutaImg,
  },
  {
    id: "fruta-maracuya",
    name: "Maracuyá",
    category: "frutas",
    lines: ["congeladas"],
    desc: "Maracuyá congelado de sabor intenso, ideal para bebidas, postres y coctelería.",
    presentations: ["400 g"],
    prices: { congeladas: { "400 g": 2260 } },
    img: MaracuyaFrutaImg,
  },
  {
    id: "fruta-mora",
    name: "Mora",
    category: "frutas",
    lines: ["congeladas"],
    desc: "Mora congelada, ideal para refrescos, batidos y repostería.",
    presentations: ["350 g"],
    prices: { congeladas: { "350 g": 2260 } },
    img: MoraFrutaImg,
  },
  {
    id: "limon-mandarino",
    name: "Jugo de Limón Mandarino",
    category: "jugos",
    lines: ["citricos"],
    desc: "Sabor cítrico y suave, perfecto para cocteles, aderezos y bebidas refrescantes. 100% natural y listo para usar.",
    presentations: ["Galón", "½ Galón", "Litro"],
    prices: {
      citricos: {
        Litro: 1600,
        "½ Galón": 2900,
        Galón: 5500,
      },
    },
    img: MandarinoImg,
  },
  {
    id: "limon-mesino",
    name: "Jugo de Limón Mesino",
    category: "jugos",
    lines: ["citricos"],
    desc: "Intenso, natural y versátil para cocina, coctelería o refrescos. Extraído de fruta real, sin saborizantes artificiales.",
    presentations: ["Galón", "½ Galón", "Litro"],
    prices: {
      citricos: {
        Litro: 1600,
        "½ Galón": 2900,
        Galón: 5500,
      },
    },
     img: MesinoImg,
  },
  {
    id: "naranja",
    name: "Jugo de Naranja Natural",
    category: "jugos",
    lines: ["citricos"],
    desc: "Jugo fresco y naturalmente dulce, ideal para desayunos, coctelería o consumo directo. Elaborado con naranjas seleccionadas.",
    presentations: ["Galón", "½ Galón", "Litro"],
    prices: {
      citricos: {
        Litro: 1600,
        "½ Galón": 2900,
        Galón: 5500,
      },
    },
    img: NaranjaImg,
  },
  {
    id: "naranja-con-remolacha",
    name: "Naranja con Remolacha",
    category: "jugos",
    lines: ["citricos"],
    desc: "Jugo natural de naranja con remolacha, listo para disfrutar con un sabor fresco y nutritivo.",
    presentations: ["Galón", "½ Galón", "Litro"],
    prices: {
      citricos: {
        Litro: 1800,
        "½ Galón": 3200,
        Galón: 5750,
      },
    },
    img: NaranjaRemolachaAltImg,
  },
  {
    id: "naranja-con-zanahoria",
    name: "Naranja con Zanahoria",
    category: "jugos",
    lines: ["citricos"],
    desc: "Mezcla refrescante de naranja y zanahoria, con sabor suave y nutritivo.",
    presentations: ["Galón", "½ Galón", "Litro"],
    prices: {
      citricos: {
        Litro: 1800,
        "½ Galón": 3100,
        Galón: 5750,
      },
    },
    img: NaranjaZanahoriaImg,
  },
  {
    id: "limonada-yerbab",
    name: "Limonada con Yerbabuena",
    category: "jugos",
    lines: ["citricos"],
    desc: "Refrescante combinación de limón natural y yerbabuena fresca. Perfecta para bares, restaurantes o consumo en casa.",
    presentations: ["Galón", "½ Galón", "Litro"],
    prices: {
      citricos: {
        Litro: 1800,
        "½ Galón": 3100,
        Galón: 5750,
      },
    },
    img: LimonadaYerbabuenaImg,
  },
  {
    id: "cas",
    name: "Pulpa de Cas",
    category: "pulpas",
    lines: ["premium"],
    desc: "Pulpa natural de cas con un toque de azúcar, ideal para preparar refrescos tradicionales de excelente sabor.",
    presentations: ["Galón", "Preparación 1:3"],
    prices: {
      premium: {
        Galón: 8500,
      },
    },
    img: CasImg,
  },
  {
    id: "fresa",
    name: "Pulpa de Fresa",
    category: "pulpas",
    lines: ["premium", "light"],
    desc: "Pulpa natural de fresa, ideal para refrescos, batidos, coctelería y postres.",
    presentations: ["Galón", "Preparación 1:3"],
    prices: {
      premium: {
        Galón: 11500,
      },
      light: {
        Galón: 13500,
      },
    },
    img: FresaImg,
  },
  {
    id: "guanabana",
    name: "Pulpa de Guanábana",
    category: "pulpas",
    lines: ["premium"],
    desc: "Pulpa cremosa y aromática, ideal para batidos, helados y refrescos naturales.",
    presentations: ["Galón", "Preparación 1:3"],
    prices: {
      premium: {
        Galón: 12000,
      },
    },
    img: GuanabanaImg,
  },
  {
    id: "manga",
    name: "Pulpa de Manga",
    category: "pulpas",
    lines: ["premium", "light"],
    desc: "Dulce, espesa y tropical. Perfecta para smoothies, repostería y coctelería.",
    presentations: ["Galón", "Preparación 1:3"],
    prices: {
      premium: {
        Galón: 7500,
      },
      light: {
        Galón: 11000,
      },
    },
    img: MangoImg,
  },
  {
    id: "maracuya",
    name: "Pulpa de Maracuyá",
    category: "pulpas",
    lines: ["premium", "light"],
    desc: "Pulpa exótica con el equilibrio justo entre acidez y dulzura. Ideal para cocteles, repostería o refrescos.",
    presentations: ["Galón", "Preparación 1:3"],
    prices: {
      premium: {
        Galón: 11500,
      },
      light: {
        Galón: 13500,
      },
    },
    img: MaracuyaImg,
  },
  {
    id: "mora",
    name: "Pulpa de Mora",
    category: "pulpas",
    lines: ["premium", "light"],
    desc: "Sabor intenso y color vibrante, perfecta para batidos, repostería y refrescos naturales.",
    presentations: ["Galón", "Preparación 1:3"],
    prices: {
      premium: {
        Galón: 10000,
      },
      light: {
        Galón: 12000,
      },
    },
    img: MoraImg,
  },
  {
    id: "pina",
    name: "Pulpa de Piña",
    category: "pulpas",
    lines: ["premium", "light"],
    desc: "Refrescante y tropical, ideal para piñas coladas, smoothies o jugos naturales.",
    presentations: ["Galón", "Preparación 1:3"],
    prices: {
      premium: {
        Galón: 7500,
      },
      light: {
        Galón: 11000,
      },
    },
    img: PinaImg,
  },
  {
    id: "mixto",
    name: "Pulpa Mixta",
    category: "pulpas",
    lines: ["premium"],
    desc: "Combinación deliciosa de frutas naturales que aportan sabor y rendimiento a cualquier preparación.",
    presentations: ["Galón", "Preparación 1:3"],
    prices: {
      premium: {
        Galón: 7500,
      },
    },
    img: MixtoImg,
  },
  {
    id: "carambola",
    name: "Carambola",
    category: "pulpas",
    lines: ["premium"],
    desc: "Pulpa natural de carambola con un toque de azúcar, perfecta para refrescos con un sabor tropical y refrescante.",
    presentations: ["Galón", "Preparación 1:3"],
    prices: {
      premium: {
        Galón: 7500,
      },
    },
    img: CarambolaImg,
  },
  {
    id: "tamarindo",
    name: "Pulpa de Tamarindo",
    category: "pulpas",
    lines: ["premium"],
    desc: "Pulpa de sabor intenso y natural, excelente para refrescos típicos, salsas o cocteles.",
    presentations: ["Galón", "Preparación 1:3"],
    prices: {
      premium: {
        Galón: 8500,
      },
    },
    img: TamarindoImg,
  },
  {
    id: "tamarindo-2l",
    name: "Pulpa de Tamarindo 2L",
    category: "pulpas",
    lines: ["light"],
    desc: "Versión práctica en presentación de 2 litros, con el mismo sabor auténtico del tamarindo natural y sin azúcar.",
    presentations: ["2 Litros", "Preparación 1:3"],
    prices: {
      light: {
        "2 Litros": 5500,
      },
    },
    img: Tamarindo2LImg,
  },
  {
    id: "pina-colada-se",
    name: "Piña Colada",
    category: "sabores",
    lines: ["sabores"],
    desc: "Base para bebidas o cocteles. Preparación sugerida: 1 parte + 3 partes de líquido. Rinde x4.",
    presentations: ["Galón", "½ Galón", "Litro"],
    prices: {
      sabores: {
        Litro: 1800,
        "½ Galón": 3500,
        Galón: 5750,
      },
    },
    img: PinaColadaPresentacionImg,
  },
  {
    id: "pina-arroz-se",
    name: "Piña con Arroz",
    category: "sabores",
    lines: ["sabores"],
    desc: "Base para bebidas o cocteles. Preparación sugerida: 1 parte + 3 partes de líquido. Rinde x4.",
    presentations: ["Galón", "½ Galón", "Litro"],
    prices: {
      sabores: {
        Litro: 1800,
        "½ Galón": 3500,
        Galón: 5750,
      },
    },
    img: PinaArrozPresentacionImg,
  },
  {
    id: "coctel-pasion-se",
    name: "Cóctel Pasión",
    category: "sabores",
    lines: ["sabores"],
    desc: "Base para bebidas o cocteles. Preparación sugerida: 1 parte + 3 partes de líquido. Rinde x4.",
    presentations: ["Galón", "½ Galón", "Litro"],
    prices: {
      sabores: {
        Litro: 1800,
        "½ Galón": 3100,
        Galón: 5750,
      },
    },
    img: CoctelPasionPresentacionImg,
  },
  {
    id: "resbaladera-se",
    name: "Resbaladera",
    category: "sabores",
    lines: ["sabores"],
    desc: "Bebida tradicional de textura cremosa y sabor auténtico. Lista para consumir y disfrutar en cualquier momento.",
    presentations: ["Galón", "½ Galón", "Litro"],
    prices: {
      sabores: {
        Litro: 1800,
        "½ Galón": 3500,
        Galón: 5750,
      },
    },
    img: ResbaladeraPresentacionImg,
  },
  {
    id: "crema-coco",
    name: "Crema de Coco",
    category: "sabores",
    lines: ["sabores"],
    desc: "Bebida cremosa de coco, lista para disfrutar con un sabor suave y tropical.",
    presentations: ["Galón", "½ Galón", "Litro"],
    prices: {
      sabores: {
        Litro: 2950,
        "½ Galón": 4300,
        Galón: 8200,
      },
    },
    img: CremaCocoImg,
  },
  {
    id: "aceite-1893",
    name: "Aceite 18.93L",
    category: "grasas",
    lines: [],
    desc: "Aceite vegetal refinado ideal para cocina profesional. Excelente rendimiento y estabilidad en fritura.",
    presentations: ["18.93 L"],
    img: Aceite1893Img,
  },
  {
    id: "aceite-oleina",
    name: "Aceite Oleína",
    category: "grasas",
    lines: [],
    desc: "Aceite vegetal 100% puro con alta resistencia a temperaturas elevadas. Ideal para freír y uso diario.",
    presentations: ["18.93 L"],
    img: AceiteOleinaImg,
  },
  {
    id: "manteca-multi",
    name: "Manteca Multipropósito",
    category: "grasas",
    lines: [],
    desc: "Manteca versátil para panadería y repostería. Proporciona textura, volumen y excelente sabor en masas.",
    presentations: ["Cubeta 15 kg", "Cubeta 7 kg"],
    img: MantecaMultiImg,
  },
  {
    id: "manteca-palma",
    name: "Manteca de Palma",
    category: "grasas",
    lines: [],
    desc: "Manteca natural derivada de palma, libre de olores y perfecta para frituras y elaboración de empanizados.",
    presentations: ["Cubeta 15 kg", "Cubeta 7 kg"],
    img: MantecaPalmaImg,
  },
  {
    id: "margarina-hojaldre",
    name: "Margarina para Hojaldre",
    category: "grasas",
    lines: [],
    desc: "Especial para hojaldres y croissants. Ofrece capas uniformes, textura crujiente y sabor balanceado.",
    presentations: ["Cubeta 15 kg", "Cubeta 7 kg"],
    img: MargarinaHojaldreImg,
  },
  {
    id: "margarina-multiproposito",
    name: "Margarina Multipropósito",
    category: "grasas",
    lines: [],
    desc: "Diseñada para panadería y repostería. Su textura suave y alto rendimiento la hacen ideal para todo uso.",
    presentations: ["Cubeta 15 kg", "Cubeta 7 kg"],
    img: MargarinaMultipropositoImg,
  },
  {
    id: "margarina-pastelera",
    name: "Margarina Pastelera",
    category: "grasas",
    lines: [],
    desc: "Especial para cremas, rellenos y repostería fina. Brinda estabilidad y un sabor delicado en cada preparación.",
    presentations: ["Cubeta 15 kg", "Cubeta 7 kg"],
    img: MargarinaPasteleraImg,
  },
];
const CATEGORY_ORDER = ["jugos", "pulpas", "sabores", "grasas", "frutas"];
const CATEGORY_LABEL = {
  jugos: "Jugos Cítricos",
  pulpas: "Pulpas Naturales",
  sabores: "Sabores Especiales",
  grasas: "Grasas & Aceites",
  frutas: "Frutas Congeladas",
};
const LINE_OPTIONS = [
  { value: "premium", label: "Premium" },
  { value: "light", label: "Light" },
  { value: "citricos", label: "Cítricos" },
  { value: "sabores", label: "Sabores Especiales" },
  { value: "congeladas", label: "Frutas Congeladas" },
];
function normalize(str = "") {
  return str
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}
function getLineLabel(lineName) {
  if (lineName === "premium") return "Premium";
  if (lineName === "light") return "Light";
  if (lineName === "citricos") return "Cítricos";
  if (lineName === "sabores") return "Sabores Especiales";
  if (lineName === "congeladas") return "Congeladas";
  if (lineName === "consultar") return "Consultar";
  return lineName;
}
function getVisiblePrices(item, activeLine) {
  if (!item.prices) return null;
  if (activeLine && item.prices[activeLine]) {
    return {
      [activeLine]: item.prices[activeLine],
    };
  }
  return item.prices;
}
function ProductCard({ item, activeLine }) {
  const visiblePrices = getVisiblePrices(item, activeLine);
  return (
    <article className="product-card" id={`detalle-${item.id}`}>
      <div className="product-media">
        <img src={item.img} alt={item.name} />
      </div>
      <div className="product-body">
        <h3 className="product-title">{item.name}</h3>
        {Array.isArray(item.lines) && item.lines.length > 0 && (
          <div className="product-meta">
            {item.lines.map((ln) => (
              <span
                key={ln}
                className={
                  ln === "premium" ||
                  ln === "light" ||
                  ln === "citricos" ||
                  ln === "sabores" ||
                    ln === "congeladas"
                    ? `line-badge ${ln}`
                    : "line-badge"
                }
              >
                {getLineLabel(ln)}
              </span>
            ))}
          </div>
        )}
        {item.desc && <p className="desc">{item.desc}</p>}
        {Array.isArray(item.presentations) && item.presentations.length > 0 && (
          <div className="presentations">
            {item.presentations.map((p) => (
              <span className="tag" key={p}>
                {p}
              </span>
            ))}
          </div>
        )}
      </div>
      <div className="actions">
  <div className="price-table">
    {visiblePrices ? (
      <div className="price-group precios-unificados">
        <h4>
          {Object.keys(visiblePrices).length === 1
            ? getLineLabel(Object.keys(visiblePrices)[0])
            : "Precios"}
        </h4>
        {Object.entries(visiblePrices).flatMap(([lineName, presentations]) =>
          Object.entries(presentations).map(([presentation, price]) => (
            <div className="price-row" key={`${lineName}-${presentation}`}>
              <span>
                {Object.keys(visiblePrices).length > 1
                  ? `${getLineLabel(lineName)} - ${presentation}`
                  : presentation}
              </span>
              <strong>₡{price.toLocaleString("es-CR")}</strong>
            </div>
          ))
        )}
        {item.category !== "frutas" && <small>+ IVA</small>}
      </div>
    ) : (
      <div className="price-group precios-unificados">
        <h4>Consultar</h4>
        {item.presentations?.map((presentation) => (
          <div className="price-row" key={presentation}>
            <span>{presentation}</span>
            <strong>Consulte</strong>
          </div>
        ))}
        <small>Precio según disponibilidad</small>
      </div>
    )}
  </div>
</div>
    </article>
  );
}
function CategorySection({ id, title, items, activeLine }) {
  if (!items || items.length === 0) return null;
  return (
    <section
      id={id}
      className="container"
      style={{ paddingTop: 8, paddingBottom: 12 }}
    >
      <h2 style={{ margin: "12px 0 8px" }}>{title}</h2>
      <div className="product-grid">
        {items.map((it) => (
          <ProductCard key={it.id} item={it} activeLine={activeLine} />
        ))}
      </div>
    </section>
  );
}
export default function Catalogo() {
  const [category, setCategory] = useState("");
  const [line, setLine] = useState("");
  const [query, setQuery] = useState("");
  const goToLine = ({ nextCategory = "", nextLine = "", sectionId = "" }) => {
    setCategory(nextCategory);
    setLine(nextLine);
    setQuery("");
    setTimeout(() => {
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 0);
  };
  const filtered = useMemo(() => {
    const q = normalize(query);
    return PRODUCTS.filter((p) => {
      const byCategory = category ? p.category === category : true;
      const byLine = line
        ? Array.isArray(p.lines) && p.lines.includes(line)
        : true;
      const byQuery = q
        ? normalize(p.name).includes(q) ||
          normalize(p.desc || "").includes(q) ||
          (p.presentations || []).some((x) => normalize(x).includes(q))
        : true;
      return byCategory && byLine && byQuery;
    });
  }, [category, line, query]);
  const grouped = useMemo(() => {
    const groups = CATEGORY_ORDER.reduce((acc, c) => ({ ...acc, [c]: [] }), {});
    for (const p of filtered) {
      if (!groups[p.category]) groups[p.category] = [];
      groups[p.category].push(p);
    }
    return groups;
  }, [filtered]);
  const chips = [
    category && {
      key: "cat",
      label: `Categoría: ${CATEGORY_LABEL[category] || category}`,
      onClear: () => setCategory(""),
    },
    line && {
      key: "line",
      label: `Línea: ${
        LINE_OPTIONS.find((o) => o.value === line)?.label || line
      }`,
      onClear: () => setLine(""),
    },
    query && {
      key: "q",
      label: `Buscar: “${query}”`,
      onClear: () => setQuery(""),
    },
  ].filter(Boolean);
  return (
    <div className="catalog-page">
      <div className="container catalog-hero">
        <h1>Catálogo de Productos</h1>
        <p>
          Explore nuestras líneas: Pulpas, Jugos Cítricos, Sabores Especiales y
          Grasas & Aceites y Frutas Congeladas.
        </p>
      </div>
      <div className="container lines-info">
        <h2 className="lines-info-title">Líneas de producto</h2>
        <p className="lines-info-text">
          En ARCODALI nos enorgullece ofrecer pulpas de fruta de las más puras y
          concentradas del mercado, elaboradas con fruta real seleccionada.
          Nuestras pulpas son 100 % naturales, sin saborizantes ni aditivos:
          solo fruta hecha pulpa, fresca y de excelente calidad.
        </p>
        <div className="lines-grid">
          <div
            className="line-card premium"
            role="button"
            tabIndex={0}
            onClick={() =>
              goToLine({
                nextCategory: "pulpas",
                nextLine: "premium",
                sectionId: "sec-pulpas",
              })
            }
            onKeyDown={(e) =>
              e.key === "Enter" &&
              goToLine({
                nextCategory: "pulpas",
                nextLine: "premium",
                sectionId: "sec-pulpas",
              })
            }
          >
            <h3>Premium</h3>
            <p>
              Pulpa de fruta con un toque de azúcar. Máxima concentración y
              sabor para refrescos, coctelería y repostería.
            </p>
          </div>
          <div
            className="line-card light"
            role="button"
            tabIndex={0}
            onClick={() =>
              goToLine({
                nextCategory: "pulpas",
                nextLine: "light",
                sectionId: "sec-pulpas",
              })
            }
            onKeyDown={(e) =>
              e.key === "Enter" &&
              goToLine({
                nextCategory: "pulpas",
                nextLine: "light",
                sectionId: "sec-pulpas",
              })
            }
          >
            <h3>Light</h3>
            <p>
              Endulzada con Natuvia, con menos calorías y un sabor más ligero.
              La opción más ligera y saludable.
            </p>
          </div>
          <div
            className="line-card citricos"
            role="button"
            tabIndex={0}
            onClick={() =>
              goToLine({
                nextCategory: "jugos",
                nextLine: "citricos",
                sectionId: "sec-jugos",
              })
            }
            onKeyDown={(e) =>
              e.key === "Enter" &&
              goToLine({
                nextCategory: "jugos",
                nextLine: "citricos",
                sectionId: "sec-jugos",
              })
            }
          >
            <h3>Jugos Cítricos</h3>
            <p>
              Jugos naturales de limón, naranja y mezclas especiales. Listos
              para usar en cocina, coctelería o bebidas refrescantes.
            </p>
          </div>
          <div
            className="line-card sabores"
            role="button"
            tabIndex={0}
            onClick={() =>
              goToLine({
                nextCategory: "sabores",
                nextLine: "sabores",
                sectionId: "sec-sabores",
              })
            }
            onKeyDown={(e) =>
              e.key === "Enter" &&
              goToLine({
                nextCategory: "sabores",
                nextLine: "sabores",
                sectionId: "sec-sabores",
              })
            }
          >
            <h3>Sabores Especiales</h3>
            <p>
              Bebidas naturales sin alcohol, con combinaciones especiales de
              frutas reales y recetas únicas para compartir y disfrutar.
            </p>
          </div>
          <div className="line-card congeladas" role="button" tabIndex={0}
            onClick={() => goToLine({ nextCategory: "frutas", nextLine: "congeladas", sectionId: "sec-frutas" })}
            onKeyDown={(e) => e.key === "Enter" && goToLine({ nextCategory: "frutas", nextLine: "congeladas", sectionId: "sec-frutas" })}>
            <h3>Frutas Congeladas</h3>
            <p>Frutas naturales congeladas, ideales para batidos, bebidas y postres.</p>
          </div>
        </div>
      </div>
      <div className="container filters" role="search">
        <div className="filters-row">
          <select
            className="select"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            aria-label="Filtrar por categoría"
          >
            <option value="">Todas las categorías</option>
            <option value="jugos">Jugos Cítricos</option>
            <option value="pulpas">Pulpas Naturales</option>
            <option value="sabores">Sabores Especiales</option>
            <option value="grasas">Grasas y Aceites</option>
              <option value="frutas">Frutas Congeladas</option>
          </select>
          <select
            className="select"
            value={line}
            onChange={(e) => setLine(e.target.value)}
            aria-label="Filtrar por línea"
          >
            <option value="">Todas las líneas</option>
            {LINE_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
          <input
            className="search"
            placeholder="        Buscar producto..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            aria-label="Buscar producto"
          />
        </div>
        {chips.length > 0 && (
          <div
            className="chips"
            aria-label="Filtros activos"
            style={{ marginTop: 12 }}
          >
            {chips.map((c) => (
              <button
                key={c.key}
                className="chip"
                onClick={c.onClear}
                title="Quitar filtro"
                style={{ cursor: "pointer", borderStyle: "dashed" }}
              >
                {c.label} ✕
              </button>
            ))}
          </div>
        )}
      </div>
      <CategorySection
        id="sec-jugos"
        title="Jugos Cítricos"
        items={grouped.jugos}
        activeLine={line}
      />
      <CategorySection
        id="sec-pulpas"
        title="Pulpas Naturales"
        items={grouped.pulpas}
        activeLine={line}
      />
      <CategorySection
        id="sec-sabores"
        title="Sabores Especiales ARCODALI"
        items={grouped.sabores}
        activeLine={line}
      />
      <CategorySection
        id="sec-grasas"
        title="Grasas & Aceites"
        items={grouped.grasas}
        activeLine={line}
      />
      <CategorySection id="sec-frutas" title="Frutas Congeladas" items={grouped.frutas} activeLine={line} />
      <a
        href="https://api.whatsapp.com/send/?phone=50686458846&text=Hola+ARCODALI%2C+quisiera+informaci%C3%B3n+del+cat%C3%A1logo.&type=phone_number&app_absent=0"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Escribir por WhatsApp"
      >
        <span className="wa-icon">💬</span>
        <span className="wa-text">Escribinos</span>
      </a>
      <Link className="btn-float" to="/" aria-label="Volver al inicio">
        ← Volver
      </Link>
      <div className="container contact-whatsapp">
        <h3>¿Listo para cotizar o hacer pedido?</h3>
        <p>Escríbanos y con gusto le atendemos de inmediato.</p>
        <a
          className="cta"
          href="https://wa.me/50686458846?text=Hola%20ARCODALI%2C%20me%20interesa%20el%20cat%C3%A1logo."
          target="_blank"
          rel="noreferrer"
        >
          💬 Contactar por WhatsApp
        </a>
      </div>
    </div>
  );
}